export default ({ selectedColourWayId, selectedVariantId, variants }) => {
  const colourMatches = variants.filter(
    ({ colourWayId }) => colourWayId === selectedColourWayId
  );

  return selectedColourWayId
    ? colourMatches.length === 1
      ? colourMatches[0]
      : { ...colourMatches[0], isVariantInStock: null }
    : variants.find(({ id }) => id === selectedVariantId);
};
